import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import styles from './Header.module.css';

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const { cartCount, fetchCartItems } = useCart();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const guestEmail = localStorage.getItem('guest_email');


  React.useEffect(() => {
    import('../../services/api').then(({ apiService }) => {
      apiService.getCategories().then(data => {
        if (Array.isArray(data)) setCategories(data);
        else if (data.categories) setCategories(data.categories);

        console.log( 'Categorias' ,data)
      });
    });
  }, []);

  // Cierra el sidebar al hacer clic fuera
  React.useEffect(() => {
    if (!sidebarOpen) return;
    const handleClick = (e) => {
      // Busca los elementos por ID o atributo data en lugar de usar clases de CSS
      const sidebar = document.getElementById('categoriesSidebar');
      const burgerBtn = document.getElementById('burgerBtn');
      if ((sidebar && sidebar.contains(e.target)) || (burgerBtn && burgerBtn.contains(e.target))) {
        return;
      }
      setSidebarOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sidebarOpen]);

  const getUserLabel = () => {
    if (user.role === 'admin') return `Admin: ${user.email}`;
    if (guestEmail) return `Invitado: ${guestEmail}`;
    return 'Mi Cuenta';
  };

  const handleLogout = () => {
    if (user.role === 'admin') {
      localStorage.removeItem('user');
      alert('Sesión admin cerrada');
    } else {
      localStorage.removeItem('guest_email');
      alert('Email de invitado removido');
    }
    window.location.reload();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.topBar}>
        <div className={styles.container}>
          <span></span>
          {(user.role === 'admin' || guestEmail) && (
            <span className={styles.userInfo}>
              {getUserLabel()}
              <button onClick={handleLogout} className={styles.logoutBtn}>
                Cerrar
              </button>
            </span>
          )}
        </div>
      </div>

      <div className={styles.mainHeader}>
        <div className={styles.container}>
          <div className={styles.logoSection}>
            <Link to="/" className={styles.logo}>
              <img src="/Nexa-Globals-Hlogo-removebg-preview.png" alt="Nexa Global Logo" />
            </Link>
          </div>

          <div className={styles.searchSection}>
            <form onSubmit={handleSearch} className={styles.searchBar}>
              <input
                type="text"
                placeholder="Buscar productos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={styles.searchInput}
              />
              <button type="submit" className={styles.searchButton}>🔍</button>
            </form>
          </div>

          <div className={styles.userSection}>
            <Link to="/Login" className={styles.headerLink}>
              <span className={styles.icon}>👤</span>
              <span>Mi Cuenta</span>
            </Link>
            <Link 
              to="/cart" 
              className={styles.headerLink}
              onClick={fetchCartItems} // Actualiza el carrito al hacer clic
            >
              <span className={styles.icon}>🛒</span>
              <span>Carrito({cartCount})</span>
            </Link>

            <Link to="/my-orders" className={styles.headerLink}>
            <span className={styles.icon}>📜</span>
            <span>mis ordenes</span>
            </Link>
          </div>
        </div>
      </div>

     
      <div className={styles.navigation}>
        <button
          id="burgerBtn"
          className={styles.burgerBtn}
          aria-label={sidebarOpen ? 'Cerrar categorías' : 'Abrir categorías'}
          onClick={() => setSidebarOpen(open => !open)}
        >
          <span className={styles.burgerIcon}>☰</span> Categorías
        </button>
        {user.role === 'admin' && (
          <Link to="/admin/dashboard" className={styles.adminLink}>
            🛠️ Panel Admin
          </Link>
        )}
      </div>

      <aside 
        id="categoriesSidebar"
        className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : styles.sidebarClosed}`}
      >
        <div className={styles.sidebarHeader}>
          <span>Categorías</span>
          <button
            className={styles.closeSidebarBtn}
            aria-label="Cerrar"
            onClick={() => setSidebarOpen(false)}
          >✕</button>
        </div>
        <ul className={styles.categoryList}>
          {categories.map(cat => (
            <li key={cat.id}>
              <Link
                to={`/search?category_slug=${cat.slug}`}
                className={styles.categoryLink}
                onClick={() => setSidebarOpen(false)}
              >
                {cat.name}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
    </header>
  );
};

export default Header;